import { ShopifyProductVariant } from '../types/api/entities/shopify';

export const formatVariantPrice = (variant: ShopifyProductVariant) => {
  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: variant.currencyCode,
  }).format(Number(variant.price));
};
